import { render, staticRenderFns } from "./FileLinkUploader.vue?vue&type=template&id=24f24799"
import script from "./FileLinkUploader.vue?vue&type=script&lang=js"
export * from "./FileLinkUploader.vue?vue&type=script&lang=js"
import style0 from "./FileLinkUploader.vue?vue&type=style&index=0&id=24f24799&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports